import { createContext } from 'react';
import { type RadioGroupState } from 'react-stately';
import type { Nullable } from '@direct-frontend/stdlib';

export const RadioGroupContext = createContext<Nullable<RadioGroupState>>(null);
